<div class="page-content container">
    <div class="page-header">
        <h1>
          {{ translationManager.getTranslation('Интерни корисници') }}
        </h1>
    </div>
    <div class="page-data shadow-sm">
        <div class="page-part">
            <div class="alert alert-info">
                <span  *ngIf="state === viewState.Edit"><i class="fa fa-info-circle"></i> {{ translationManager.getTranslation('Страница за измену података о интерним корисницима, молимо попуните потребне податке, сачувати промене притиском на дугме "Сачувај"') }}</span>
                <span  *ngIf="state === viewState.Details"><i class="fa fa-info-circle"></i> {{ translationManager.getTranslation('Страница за детаљни преглед интерних корисника') }}</span>
            </div>
        </div>
        
        <div class="page-part">
            <div class="form-blocks">
                <div class="form-block amb-15">
                     <div class="header">
                        <span>{{ translationManager.getTranslation('Општи подаци') }}</span>
                    </div> 

                    <div class="content">
                        <div class="form-element amb-5" >
                            <input type="hidden"  name="id" [(ngModel)]="form.elements['id'].value">    
                        </div>  
                       
                        
                        <div class="page-part"  *ngIf="state === viewState.Details">
                            <!-- <p>Works details</p> -->
                            <div class="form-element amb-5" >
                                <label>{{ translationManager.getTranslation('ЕРПИД') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['userErpId'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>  
                          
                            <div class="form-element amb-5"  >
                                <label>{{ translationManager.getTranslation('Име') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['firstName'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>  
                            <div class="form-element amb-5"  >
                                <label>{{ translationManager.getTranslation('Презиме') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['lastName'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>  
                            <div class="form-element amb-5"  >
                                <label>{{ translationManager.getTranslation('Емаил') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['email'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>  
                            <div class="form-element amb-5"  >
                                <label>{{ translationManager.getTranslation('Корисничко име') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['username'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>   
                            <div class="form-element amb-5"  >
                                <label>{{ translationManager.getTranslation('Статус') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['userStatusName'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-element amb-5"  >
                                <label>{{ translationManager.getTranslation('Први надређени ЕРПИД') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['userFirstSuperiorFullName'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>   

                            <div class="form-element amb-5"  >
                                <label>{{ translationManager.getTranslation('Компанија') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['companyName'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>   

                            <div class="form-element amb-5"  >
                                <label>{{ translationManager.getTranslation('Организациона јединица') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['organizationalUnitName'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>   

                            <div class="form-element amb-5"  >
                                <label>{{ translationManager.getTranslation('Кадровска област') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['personnelAreaName'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>   
                            <div class="form-element amb-5"  >
                                <label>{{ translationManager.getTranslation('Позиција') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['employeePositionName'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>   

                            <div class="form-element amb-5" >
                                <label>{{ translationManager.getTranslation('Изменио') }}</label>
                                <div class="content">
                                    <div class="static">    
                                    <span>{{ form.elements['userUpdateFullName'].value | appvalue }}</span>
                                    </div>
                                </div>
                            </div>  
                            <div class="page-part">
                                <div class="form-element amb-5" >
                                    <label>{{ translationManager.getTranslation('Датум измене') }}</label>
                                    <div class="content">
                                        <div class="static">    
                                        <span>{{ form.elements['updatedOn'].value | appvalue }}</span>
                                        </div>
                                    </div>
                                </div>  
                            </div> 
                            <div class="form-element amb-5"  >
                                <div class="app-table">
                                    <table class="table text-dark-m1">
                                        <thead>
                                            <tr class="bgc-primary-tp2 text-white">
                                                <th>
                                                {{ translationManager.getTranslation('Назив улоге/групе') }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of model.rolesNameAndId">
                                                <td>{{item.name}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="no-content" *ngIf="!model.rolesNameAndId || model.rolesNameAndId.length == 0">
                                        <span>{{ translationManager.getTranslation('Без података') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                       
                        <div class="page-part" *ngIf="state === viewState.Edit">
                                <!-- <p>Work in edit</p> -->
                                <div class="form-element amb-5" >
                                    <label>{{ translationManager.getTranslation('ЕРПИД') }}</label>
                                    <div class="content">
                                           <input  type="text" name="name" [(ngModel)]="form.elements['userErpId'].value" readonly>
                                    </div>
                                </div>  
                                <div class="form-element amb-5"  >
                                    <label>{{ translationManager.getTranslation('Име') }}</label>
                                    <div class="content">
                                     
                                        
                                        <input  type="text" name="name" [(ngModel)]="form.elements['firstName'].value" readonly>
                                     
                                    </div>
                                </div>  
                                <div class="form-element amb-5"  >
                                    <label>{{ translationManager.getTranslation('Презиме') }}</label>
                                    <div class="content">
                                     
                                            <input  type="text" name="name" [(ngModel)]="form.elements['lastName'].value" readonly>
                                     
                                    </div>
                                </div>  
                                <div class="form-element amb-5"  >
                                    <label>{{ translationManager.getTranslation('Емаил') }}</label>
                                    <div class="content">
                                     
                                            <input  type="text" name="name" [(ngModel)]="form.elements['email'].value" readonly>
                                     
                                    </div>
                                </div>  
                                <div class="form-element amb-5"  >
                                    <label>{{ translationManager.getTranslation('Корисничко име') }}</label>
                                    <div class="content">
                                     
                                            <input  type="text" name="name" [(ngModel)]="form.elements['username'].value" readonly>
                                     
                                    </div>
                                </div>   
                                <div class="form-element  amb-5" [ngClass]="{ 'error': form.elements['userStatusId'].error.required || form.elements['userStatusId'].error.invalid }">
                                      <label>{{ translationManager.getTranslation('Статус') }}</label>
                                      <div class="content" *ngIf="state === viewState.Edit">
                                        <select [(ngModel)]="form.elements['userStatusId'].value"
                                          (change)="changeuserStatusId($event.target.value)">
                                          <option></option>
                                          <option *ngFor="let item of userstatusmodel" [value]="item.id">{{item.name }}</option>
                                      </select>
                                      </div>
                                      <div class="errors">
                                        <span *ngIf="form.elements['userStatusId'].error.required">
                                          <i
                                            class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
                                      </div>
                                      
                                </div>
                                <div class="form-element amb-5"  >
                                    <label>{{ translationManager.getTranslation('Први надређени ЕРПИД') }}</label>
                                    <div class="content">
                                     
                                            <input  type="text" name="name" [(ngModel)]="form.elements['userFirstSuperiorFullName'].value" readonly>
                                     
                                    </div>
                                </div>   
    
                                <div class="form-element amb-5"  >
                                    <label>{{ translationManager.getTranslation('Компанија') }}</label>
                                    <div class="content">
                                     
                                            <input  type="text" name="name" [(ngModel)]="form.elements['companyName'].value" readonly>
                                     
                                    </div>
                                </div>   
    
                                <div class="form-element amb-5"  >
                                    <label>{{ translationManager.getTranslation('Организациона јединица') }}</label>
                                    <div class="content">
                                     
                                            <input  type="text" name="name" [(ngModel)]="form.elements['organizationalUnitName'].value" readonly>
                                     
                                    </div>
                                </div>   
    
                                <div class="form-element amb-5"  >
                                    <label>{{ translationManager.getTranslation('Кадровска област') }}</label>
                                    <div class="content">
                                     
                                            <input  type="text" name="name" [(ngModel)]="form.elements['personnelAreaName'].value" readonly>
                                     
                                    </div>
                                </div>   
                                
                            
                                <div class="form-element amb-5"  >
                                    <label>{{ translationManager.getTranslation('Позиција') }}</label>
                                    <div class="content">
                                     
                                            <input  type="text" name="name" [(ngModel)]="form.elements['employeePositionName'].value" readonly>
                                     
                                    </div>
                                </div>   
    
                                <div class="form-element amb-5" >
                                    <label>{{ translationManager.getTranslation('Изменио') }}</label>
                                    <div class="content">
                                     
                                            <input  type="text" name="name" [(ngModel)]="form.elements['userUpdateFullName'].value" readonly>
                                     
                                    </div>
                                </div>  
                                <div class="page-part">
                                    <div class="form-element amb-5" >
                                        <label>{{ translationManager.getTranslation('Датум измене') }}</label>
                                        <div class="content">
                                                <input  type="text" name="name" [(ngModel)]="form.elements['updatedOn'].value" readonly>
                                        </div>
                                    </div>  
                                </div> 

                                <div class="form-element amb-5"  >
                                    
                                     <div class="page-part" >
                                        <div class="page-actions">
                                            <button class="btn btn-success" (click)="addRole()"><i class="fa fa-plus mr-1"></i> {{ translationManager.getTranslation('Додати нову ролу') }}</button>
                                        </div>

                                    </div>


                                    <div class="app-table">
                                        <table class="table text-dark-m1">
                                            <thead>
                                                <tr class="bgc-primary-tp2 text-white">
                                                    <th>
                                                    {{ translationManager.getTranslation('Назив улоге/групе') }}
                                                    </th>
                                                    <th class="right">{{ translationManager.getTranslation('Акције') }}</th>
                                                </tr>

                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of model.rolesNameAndId">
                                                    <td>{{item.name}}</td>
                                                    <td class="right">
                                                        <div class="table-actions">
                                                            <a href="javascript:;" (click)="deleteRole(item.id)" class="red" [title]="translationManager.getTranslation('Брисање')">
                                                                <i class="far fa-trash-alt"></i>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="no-content" *ngIf="!model.rolesNameAndId || model.rolesNameAndId.length == 0">
                                            <span>{{ translationManager.getTranslation('Без података') }}</span>
                                        </div>
                                    </div> 
                                </div>




                        </div>

                     
                        <div class="form-element-buttons">
                        

                            <button class="btn btn-success fr" (click)="submit()"
                            *ngIf="state === viewState.Edit">
                            <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Сачувај') }}</button>
                          
                            <button class="btn btn-warning" (click)="back()"  *ngIf="state === viewState.Edit"><i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Одустани') }}</button>
                            <button class="btn btn-warning" (click)="back()"  *ngIf="state === viewState.Details"><i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>
                        </div>      
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<roles-select #roleSelect></roles-select>